// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup-container{display:none;position:absolute;top:0px;left:0px;z-index:9999;outline:none}.popup-container.visible{display:block}", ""]);
// Exports
module.exports = exports;
